<template>
  <b-container fluid class="animated fadeIn">
    <template v-if="cnpjRetorno === null && cpfRetorno === null && cndRetorno === null && doiRetorno === null && cafirRetorno === null">
      <div class="d-flex align-items-center">
        <b-col>
          <h1 class="app-title mt-4">
            Consulta - Receita Federal
          </h1>
        </b-col>
      </div>
      <b-card>
        <b-alert variant="warning" show>
          <span><i class="fa fa-warning"></i>&nbsp;&nbsp;&nbsp;&nbsp;<strong>IMPORTANTE - Uso Responsável do Sistema</strong></span><br>
          <span><strong>Cada consulta realizada nesta plataforma gera um custo para a Procuradoria-Geral do Estado</strong>, referente à utilização dos serviços do SERPRO (Infoconv).</span><br>
          <span>Ao prosseguir com a consulta, você <strong>consente</strong> com o registro da operação e a vinculação das suas credenciais à consulta realizada. <strong>Todas as consultas são registradas</strong> com os dados do usuário logado.</span>
        </b-alert>

        <b-row class="col-12 mb-0" style="padding-left: 30px">
          <b>Pesquisa Cadastral:</b>
          <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
             v-b-popover.hover.top="'Consulta CPF/CNPj da Receita Federal.'">
          </i>
        </b-row>
        <b-row class="col-12">
          <b-col sm="12">
            <b-form-radio-group
                v-model="opcaoPesquisaCadastral"
                :options="pesquisaCadastral.options"
                @change="trocaOpcaoCadastral"
            >
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="col-12" v-if="opcaoPesquisaCadastral === 'cnpj'">
          <b-col sm="6" md="3">
            <b-form-group
                label="Informe o número CNPJ:"
                label-for="cnpj"
                class="text-label">
              <b-form-input
                  type="text"
                  id="cnpj"
                  v-model="cnpj"
                  v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                  @input="formatarValidarCnpj"
                  maxlength="18"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="col-12" v-if="opcaoPesquisaCadastral === 'cpf'">
          <b-col sm="6" md="3">
            <b-form-group
                label="Informe o CPF (um CPF por linha até no máximo 50):"
                label-for="cpfs"
                class="text-label">
              <b-form-textarea id="cpfs" v-model="cpfs" rows="5" @input="limparOutros(1)">
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="col-12 mb-0" style="padding-left: 30px">
          <b>Pesquisa CND:</b>
          <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
             v-b-popover.hover.top="'Consulta Certidão Negativa de Débitos Federais'">
          </i>
        </b-row>
        <b-row class="col-12">
          <b-col sm="6" md="3">
            <b-form-group
                label="Informe o CPF / CNPJ:"
                label-for="cnd"
                class="text-label">
              <b-form-input
                  type="text"
                  id="cpfCnpj"
                  v-model="cpfCnpj"
				  v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                  @input="formatarCpfCnpj"
                  maxlength="18"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="col-12 mb-0" style="padding-left: 30px">
          <b>Pesquisa DOI:</b>
          <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
             v-b-popover.hover.top="'Consulta Declaração sobre Operações Imobiliárias'">
          </i>
        </b-row>
        <b-row class="col-12">
          <b-col sm="6" md="3">
            <b-form-group
                label="Informe o Número do NI:"
                label-for="ni"
                class="text-label">
              <b-form-input id="ni" v-model="ni" type="text" @input="limparOutros(3)">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6" md="3">
            <b-form-group
                label="Informe a data de início:"
                label-for="dataInicio"
                class="text-label">
              <b-input v-model="dataInicio" type="date" placeholder @input="limparOutros(3)"></b-input>
            </b-form-group>
          </b-col>
          <b-col sm="6" md="3">
            <b-form-group
                label="Informe a data de fim: (Período máximo de 12 meses)"
                label-for="dataFim"
                class="text-label">
              <b-input v-model="dataFim" type="date" placeholder @input="limparOutros(3)"></b-input>
            </b-form-group>
          </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row class="col-12 mb-0" style="padding-left: 30px">
          <b>Pesquisa CAFIR:</b>
          <i class="fa fa-info-circle fa-12x text-info ml-2" variant="info"
             v-b-popover.hover.top="'Consulta Cadastro de Imoveis Rurais - CAFIR'">
          </i>
        </b-row>
        <b-row class="col-12">
          <b-col sm="6" md="3">
            <b-form-group
                label="Informe o Número do NIRF:"
                label-for="nirf"
                class="text-label">
              <b-form-input id="nirf" v-model="nirf" type="text" @input="limparOutros(4)">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <hr class="mt-4 mb-4"/>

        <div class="row justify-content-center">
          <div class="d-flex justify-content-between mb-3">
            <div>
              <b-button
                  id="btnProxima"
                  @click="pesquisar"
                  variant="primary">
                Pesquisar
              </b-button>
            </div>
          </div>
        </div>
        <CompLoading ref="loading"/>
      </b-card>
    </template>
    <template v-else>
      <b-row>
        <b-col>
          <h1 class="app-title mt-4">
            Exibir Pesquisa Cadastral
          </h1>
        </b-col>
      </b-row>
      <b-card>
        <b-row class="col-12 mb-0" style="padding-left: 20px; padding-top: 10px;" v-if="verificarRetornoMultiplo()">
          <b>Mais de um registro identificado! Acesse o resultado pelos botões "Exportar CSV" ou "Exportar PDF".</b>
        </b-row>
        <template v-if="cnpjRetorno !== null && cnpjRetorno.cnpjs.length === 1">
          <b-row class="mt-4 row-dados">
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CNPJ consultado:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].cnpj }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Estabelecimento:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].estabelecimento }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome Empresarial:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].nomeEmpresarial }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome Fantasia:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].nomeFantasia }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Situação Cadastral:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].situacaoCadastral }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Motivo Situação:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].motivoSituacao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data Situação Cadastral:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].dataSituacaoCadastral }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Cidade Exterior:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].cidadeExterior }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Codigo País:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].codigoPais }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome País:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].nomePais }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Natureza Jurídica:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].naturezaJuridica }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data Abertura:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].dataAbertura }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CNAE Principal:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].cnaePrincipal }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CNAE Secundário:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].cnaeSecundario.join(', ') }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Tipo Logradouro:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].tipoLogradouro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Logradouro:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].logradouro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Número Logradouro:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].numeroLogradouro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Complemento:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].complemento }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Bairro:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].bairro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CEP:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].cep }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">UF:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].uf }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Código Município:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].codigoMunicipio }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome Município:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].nomeMunicipio }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Referência:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].referencia }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">DDD 1:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].ddd1 }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Telefone 1:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].telefone1 }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">DDD 2:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].ddd2 }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Telefone 2:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].telefone2 }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">E-mail:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].email }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CPF Responsável:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].cpfResponsavel }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome Responsável:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].nomeResponsavel }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Capital Social:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].capitalSocial }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Porte:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].porte }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Opção Simples:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].opcaoSimples }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Opção SIMEI:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].opcaoSimei }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Situação Especial:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].situacaoEspecial }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data Situação Especial:</span>
                  <span class="mr-sm-2 valor-dados">{{ cnpjRetorno.cnpjs[0].dataSituacaoEspecial }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
              </b-form>
            </b-col>

            <template v-if="cnpjRetorno.cnpjs[0].sociedades.length > 0">
              <p class="item-dados mt-4" style="font-size: 1.2rem !important">Sociedades</p>
              <b-table
                  striped hover bordered responsive
                  :items="cnpjRetorno.cnpjs[0].sociedades"
                  :busy="false"
                  :fields="tbSociedade"
                  class="mt-1 table-sociedade"
                  head-variant="light"
                  small
              >
              </b-table>
            </template>
          </b-row>
        </template>
        <template v-else-if="cpfRetorno !== null && cpfRetorno.cpfs.length === 1">
          <b-row class="mt-4 row-dados">
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CPF consultado:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].cpf }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].nome }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Situação Cadastral:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].situacaoCadastral }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Residente Exterior:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].residenteExterior }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Código País Exterior:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].codigoPaisExterior }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome País Exterior:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].nomePaisExterior }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome Mãe:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].nomeMae }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data Nascimento:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].dataNascimento }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Sexo:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].sexo }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Natureza Ocupação:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].naturezaOcupacao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Ocupação Principal:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].ocupacaoPrincipal }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Exercício Ocupação:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].exercicioOcupacao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Tipo Logradouro:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].tipoLogradouro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Logradouro:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].logradouro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Número Logradouro:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].numeroLogradouro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Complemento:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].complemento }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Bairro:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].bairro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CEP do Domicílio Fiscal:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].cep }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">UF:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].uf }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Código Município:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].codigoMunicipio }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Município:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].municipio }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">DDD do Telefone:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].ddd }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Telefone:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].telefone }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Unidade Administrativa:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].unidadeAdministrativa }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Ano Óbito:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].anoObito }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Estrangeiro:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].estrangeiro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Código País Nacionalidade:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].codPaisNacionalidade }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome País Nacionalidade:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].nomePaisNacionalidade }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data Atualização:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].dataAtualizacao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data Inscrição:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].dataInscricao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Código Município Naturalidade:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].codigoMunicipioNaturalidade }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome Município Naturalidade:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].nomeMunicipioNaturalidade }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">UF Município Naturalidade:</span>
                  <span class="mr-sm-2 valor-dados">{{ cpfRetorno.cpfs[0].ufMunicipioNaturalidade }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col xs="12" sm="12" md="6" class="item-direita">
              <b-form inline>
              </b-form>
            </b-col>
          </b-row>
        </template>
        <template v-else-if="cndRetorno !== null && cndRetorno.dados !== null">
          <b-row class="mt-4 row-dados">
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Existência de Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.informaExistenciaCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data de Validade da Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.dataValidadeCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data de Emissão da Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.dataEmissaoCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Hora de Emissão da Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.horaEmissaoCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Código de Controle da Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.codigoControleCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Tipo NI da Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.indNiCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">NI da Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.niCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome do Contribuinte:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.nomeContribuinteCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Situação Cadastral:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.indSituacaoCadastralCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Tipo de Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.tipoCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Observação RFB:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.obsRFBCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Observação PGFN:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.obsPGFNCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Observação Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.indObservacaoCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Modelo da Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.codModeloCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Existência de Termo de Arrolamento:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.indExigTermoArrolCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Local Emissão da Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.indLocalEmissaoCertidao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Parcelamento Certidão:</span>
                  <span class="mr-sm-2 valor-dados">{{ cndRetorno.dados.indParcCertidao }}</span>
                </p>
              </b-form>
            </b-col>
          </b-row>
        </template>
        <template v-else-if="doiRetorno !== null && doiRetorno.dados.length === 1">
          <b-row class="mt-4 row-dados">
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CPF ou CNPJ:</span>
                  <span class="mr-sm-2 valor-dados">{{ doiRetorno.dados[0].cpfCnpj }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome ou Nome Empresarial:</span>
                  <span class="mr-sm-2 valor-dados">{{ doiRetorno.dados[0].nome }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Tipo da declaração:</span>
                  <span class="mr-sm-2 valor-dados">{{ doiRetorno.dados[0].tipoDeclaracao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CNPJ do cartório:</span>
                  <span class="mr-sm-2 valor-dados">{{ doiRetorno.dados[0].cnpjCartorio }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Atribuição registral:</span>
                  <span class="mr-sm-2 valor-dados">{{ doiRetorno.dados[0].atribuicaoRegistral }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Data da lavratura, registro ou averbação:</span>
                  <span class="mr-sm-2 valor-dados">{{ doiRetorno.dados[0].dataLavraturaRegistroAverbacao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Livro:</span>
                  <span class="mr-sm-2 valor-dados">{{ doiRetorno.dados[0].livro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Folha:</span>
                  <span class="mr-sm-2 valor-dados">{{ doiRetorno.dados[0].folha }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Matricula:</span>
                  <span class="mr-sm-2 valor-dados">{{ doiRetorno.dados[0].matricula }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Registro:</span>
                  <span class="mr-sm-2 valor-dados">{{ doiRetorno.dados[0].registro }}</span>
                </p>
              </b-form>
            </b-col>
          </b-row>
        </template>
        <template v-else-if="cafirRetorno !== null && cafirRetorno.dados !== null">
          <b-row class="mt-4 row-dados">
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Número do Imóvel:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.cib }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Área Total do Imóvel:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.areaTotal }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Código do Imóvel no INCRA:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.codigoIncra }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome do Imóvel Rural:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.nomeImovel }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Situação cadastral do Imóvel:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.situacao }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Logradouro:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.logradouro }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Distrito:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.distrito }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">UF do município de localização do Imóvel:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.uf }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Município de localização do Imóvel:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.municipio }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CEP:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.cep }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">NI do proprietário:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.niContribuinte }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome do proprietário:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.nomeContribuinte }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CPF do Cônjuge:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.cpfConjuge }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CPF do Inventariante:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.cpfInventariante }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome do Inventariante:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.nomeInventariante }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">CPF do Representante Legal:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.cpfRepresentanteLegal }}</span>
                </p>
              </b-form>
            </b-col>
            <b-col lg="12">
              <b-form inline>
                <p>
                  <span class="mr-sm-2 item-dados">Nome do Representante Legal:</span>
                  <span class="mr-sm-2 valor-dados">{{ cafirRetorno.dados.nomeRepresentanteLegal }}</span>
                </p>
              </b-form>
            </b-col>
          </b-row>
        </template>

        <hr class="mt-4 mb-4"/>

        <div class="row justify-content-center">
          <div class="d-flex justify-content-between mb-3">
            <div>
              <b-button
                  class="fonte-branca ml-1"
                  variant="secondary"
                  @click.prevent="voltar()">
                <i class="fa fa-reply"></i> Voltar
              </b-button>
              <b-button
                  class="fonte-branca ml-1"
                  variant="primary"
                  @click.prevent="exportarCsv()"
              >
                <i class="fa fa-file-excel-o"></i> Exportar CSV
              </b-button>
              <b-button
                  class="fonte-branca ml-1"
                  variant="primary"
                  @click.prevent="exportarPdf()"
              >
                <i class="fa fa-file-pdf-o"></i> Exportar PDF
              </b-button>
            </div>
          </div>
        </div>
      </b-card>
    </template>
  </b-container>
</template>

<script>
import axios from 'axios';
import formatarMixins from '../../mixins/formatarMixins';
import store from "@/store/store";
import CompLoading from "@/views/shared/components/CompLoading.vue";

export default {
  components: {CompLoading},
  mixins: [formatarMixins],
  data() {
    return {
      urlApi: null,
      token: null,
      pesquisaCadastral: {
        selected: "cnpj",
        options: [
          { text: "CNPJ", value: "cnpj" },
          { text: "CPF", value: "cpf" }
        ],
      },
      opcaoPesquisaCadastral: "cnpj",
      cnpj: null,
      cpfs: null,
      cpfCnpj: null,
      ni: null,
      dataInicio: null,
      dataFim: null,
      nirf: null,
      cnpjRetorno: null,
      cpfRetorno: null,
      cndRetorno: null,
      doiRetorno: null,
      cafirRetorno: null,
      tbSociedade: [
        {
          key: "tipo",
          label: "Tipo",
        },
        {
          key: "nome",
          label: "Nome",
        },
        {
          key: "numero",
          label: "Número",
        },
        {
          key: "qualificacao",
          label: "Qualificação",
        },
        {
          key: "codigoPaisOrigem",
          label: "Código País Origem",
        },
        {
          key: "nomePaisOrigem",
          label: "Nome País Origem",
        }
      ],
    }
  },
  methods: {
    trocaOpcaoCadastral() {
      this.cnpj = null
      this.cpfs = null
      store.dispatch('limparMensagens')
    },
    formatarValidarCnpj(e) {
      this.limparOutros(1);
      let formatado = this.formatarCNPJ(e);

      if (formatado.length === 18) {
        this.validarCnpj(formatado);
      }

      this.cnpj = formatado;
    },

    formatarCpfCnpj(e) {
      this.limparOutros(2);

      let valor = e.toUpperCase().replace(/[^\w]/g, '');

      let formatado;
      if (/[a-zA-Z]/.test(valor) || valor.length > 11) {
        formatado = this.formatarCNPJ(e);
      } else {
        formatado = this.formatarCPF(e);
      }

      this.cpfCnpj = formatado;
    },

    validarCnpj(cnpj) {
      const limpo = cnpj.replace(/[^\w]/g, '').toUpperCase();
      if (!this.validarCNPJAlfanumerico(limpo)) {
        this.exibirErro(`CNPJ inválido: ${cnpj}`)
        return false
      }
      store.dispatch('limparMensagens')
      return true
    },

    validarCpfInformado(cpf) {
      if (!this.validarCpf(cpf)) {
        this.exibirErro(`CPF inválido: ${cpf}`)
        return false
      }
      store.dispatch('limparMensagens')
      return true
    },

    verificarPreenchimento(campo) {
      return campo && campo.trim() !== '';
    },

    async pesquisar() {
      store.dispatch('limparMensagens')
      if(this.opcaoPesquisaCadastral === 'cnpj' && this.verificarPreenchimento(this.cnpj)) {
        if(!this.validarCnpj(this.cnpj)) {
          return
        }

        this.$refs.loading.showLoading()
        axios.get(`${this.urlApi}/v1/infoconv/cnpj/${this.cnpj.replace(/[^\w]/g, '').toUpperCase()}`,{
          headers: {
            'Authorization': this.token,
            'Content-Type': 'application/json',
          }
        }).then(response => {
          let data = response.data;

          if (!data || !data.cnpjs) {
            this.exibirErro(`Ocorreu um erro inesperado ao realizar a pesquisa cadastral.`)
            return
          }

          for (let i = 0; i < data.cnpjs.length; i++) {
            let cnpj = data.cnpjs[i];
            if (cnpj.codigoRetorno != null) {
              this.exibirErro(`${cnpj.mensagem}: ${cnpj.cnpj}`)
              return
            }
          }

          this.cnpjRetorno = data
        }).catch((error) => {
          this.exibirErro(error)
        }).finally(() => {
          this.$refs.loading.hideLoading()
        });
      } else if(this.opcaoPesquisaCadastral === 'cpf' && this.verificarPreenchimento(this.cpfs)) {
        let existeCpf = false
        if(this.cpfs) {
          for(const cpf of this.cpfs.split('\n')) {
            if (cpf.trim() !== "") {
              existeCpf = true
            }
          }
        }
        if(!existeCpf) {
          this.exibirErro(`Ao menos um CPF deve ser informado para realizar a pesquisa!`)
          return
        }


        if (this.cpfs.split('\n').length > 50) {
          this.exibirErro('Máximo de 50 CPFs por pesquisa.')
          return
        }

        let cpfs = []
        let mensagemErro = ''
        for(const cpf of this.cpfs.split('\n')) {
          if (cpf.trim() !== "") {
            if (!this.validarCpf(cpf)) {
              if (mensagemErro !== '') {
                mensagemErro += `<br/>`
              }
              mensagemErro += `CPF inválido: ${cpf.trim()}`
            } else {
              cpfs.push(cpf.trim().replace(/[^\w]/g, ''))
            }
          }
        }

        if (mensagemErro !== '') {
          this.exibirErro(mensagemErro)
          return
        }

        this.$refs.loading.showLoading()
        axios.post(`${this.urlApi}/v1/infoconv/cpf`, {"cpfs": cpfs}, {
          headers: {
            'Authorization': this.token,
            'Content-Type': 'application/json',
          }
        }).then(response => {
          let data = response.data

          if (!data || !data.cpfs) {
            this.exibirErro(`Ocorreu um erro inesperado ao realizar a pesquisa cadastral.`)
            return
          }

          let mensagemErro = ''
          for (let i = 0; i < data.cpfs.length; i++) {
            let cpf = data.cpfs[i];
            if (cpf.codigoRetorno != null) {
              if (mensagemErro !== '') {
                mensagemErro += `<br/>`
              }
              mensagemErro += `${cpf.mensagem}: ${cpf.cpf}`
            }
          }

          if (mensagemErro !== '') {
            this.exibirErro(mensagemErro)
            return
          }

          this.cpfRetorno = data
        }).catch((error) => {
          this.exibirErro(error)
        }).finally(() => {
          this.$refs.loading.hideLoading()
        });
      } else if(this.verificarPreenchimento(this.cpfCnpj)) {
        if(this.cpfCnpj.length <= 14) {
          if(!this.validarCpfInformado(this.cpfCnpj)) {
            return
          }
        } else {
          if(!this.validarCnpj(this.cpfCnpj)) {
            return
          }
        }

        this.$refs.loading.showLoading()
        axios.get(`${this.urlApi}/v1/infoconv/cnd/${this.cpfCnpj.replace(/[^\w]/g, '').toUpperCase()}`,{
          headers: {
            'Authorization': this.token,
            'Content-Type': 'application/json',
          }
        }).then(response => {
          let data = response.data;

          if (!data || !data.dados) {
            this.exibirErro(`Ocorreu um erro inesperado ao buscar a CND.`)
            return
          }

          if (data.dados.codigoRetorno != null && data.dados.codigoRetorno !== 1) {
            let mensagem = data.dados.mensagem
            if (!mensagem.endsWith('.')) {
              mensagem += '.'
            }
            this.exibirErro(`${mensagem} CNPJ/CPF: ${this.cpfCnpj}`)
            return
          }

          this.cndRetorno = data
        }).catch((error) => {
          this.exibirErro(error)
        }).finally(() => {
          this.$refs.loading.hideLoading()
        });
      } else if(this.verificarPreenchimento(this.ni) || this.verificarPreenchimento(this.dataInicio) || this.verificarPreenchimento(this.dataFim)) {
        if(!this.verificarPreenchimento(this.ni) || !this.verificarPreenchimento(this.dataInicio) || !this.verificarPreenchimento(this.dataFim)) {
          this.exibirErro(`Informe todos os campos para a Pesquisa DOI!`)
          return
        }

        const dataInicial = parseInt(this.dataInicio.split("-")[0] + "" + this.dataInicio.split("-")[1] + "" + this.dataInicio.split("-")[2]);
        const dataFim = parseInt(this.dataFim.split("-")[0] + "" + this.dataFim.split("-")[1] + "" + this.dataFim.split("-")[2]);

        const diffDays = Math.floor(Math.abs(new Date(this.dataFim) - new Date(this.dataInicio)) / (1000 * 60 * 60 * 24));

        if(dataInicial > dataFim) {
          this.exibirMensagem("A Data de Início não pode ser maior que a Data Final.");
          return;
        } else if (diffDays > 366) {
          this.exibirMensagem("O intervalo entre a Data de Início e a Data Final não pode ser maior que 12 meses.");
          return;
        }

        const request = {
          ni: this.ni.replace(/[^\w]/g, '').toUpperCase(),
          dataInicio: this.dataInicio,
          dataFim: this.dataFim
        }

        this.$refs.loading.showLoading()
        axios.post(`${this.urlApi}/v1/infoconv/doi`, request,{
          headers: {
            'Authorization': this.token,
            'Content-Type': 'application/json',
          }
        }).then(response => {
          let data = response.data

          if (!data || !data.dados) {
            this.exibirErro(`Ocorreu um erro inesperado ao buscar o DOI.`)
            return
          }

          let mensagemErro = ''
          for (let i = 0; i < data.dados.length; i++) {
            let dado = data.dados[i];
            if (dado.codigoRetorno != null) {
              if (mensagemErro !== '') {
                mensagemErro += `<br/>`
              }
              mensagemErro += `${dado.mensagem}`
            }
          }

          if (mensagemErro !== '') {
            this.exibirErro(mensagemErro)
            return
          }

          this.doiRetorno = data
        }).catch((error) => {
          this.exibirErro(error)
        }).finally(() => {
          this.$refs.loading.hideLoading()
        });
      } else if(this.verificarPreenchimento(this.nirf)) {
        this.$refs.loading.showLoading()
        axios.get(`${this.urlApi}/v1/infoconv/cafir/${this.nirf.replace(/[^\w]/g, '').toUpperCase()}`,{
          headers: {
            'Authorization': this.token,
            'Content-Type': 'application/json',
          }
        }).then(response => {
          let data = response.data;

          if (!data || !data.dados) {
            this.exibirErro(`Ocorreu um erro inesperado ao buscar o NIRF.`)
            return
          }

          if (data.dados.codigoRetorno != null) {
            let mensagem = data.dados.mensagem
            if (!mensagem.endsWith('.')) {
              mensagem += '.'
            }
            this.exibirErro(`${mensagem} NIRF: ${this.nirf}`)
            return
          }

          this.cafirRetorno = data
        }).catch((error) => {
          this.exibirErro(error)
        }).finally(() => {
          this.$refs.loading.hideLoading()
        });
      }
    },

    voltar() {
      this.cnpjRetorno = null;
      this.cpfRetorno = null;
      this.cndRetorno = null;
      this.doiRetorno = null;
      this.cafirRetorno = null;
      this.cnpj = null;
      this.cpfs = null;
      this.cpfCnpj = null;
      this.nirf = null;
      this.ni = null;
      this.dataInicio = null;
      this.dataFim = null;
      this.opcaoPesquisaCadastral = "cnpj";
      store.dispatch('limparMensagens');
    },

    limparOutros(pesquisa) {
      store.dispatch('limparMensagens');
      if(pesquisa == 1) {
        this.cpfCnpj = null;
        this.ni = null;
        this.dataInicio = null;
        this.dataFim = null;
        this.nirf = null;
      } else if(pesquisa == 2) {
        this.cnpj = null;
        this.cpfs = null;
        this.ni = null;
        this.dataInicio = null;
        this.dataFim = null;
        this.nirf = null;
      } else if(pesquisa == 3) {
        this.cnpj = null;
        this.cpfs = null;
        this.cpfCnpj = null;
        this.nirf = null;
      } else if(pesquisa == 4) {
        this.cnpj = null;
        this.cpfs = null;
        this.cpfCnpj = null;
        this.ni = null;
        this.dataInicio = null;
        this.dataFim = null;
      }
    },

    exportarCsv() {
      let nomeArquivo;
      let base64;
      if (this.cnpjRetorno !== null) {
        nomeArquivo = `pesquisa_cadastral_cnpj.csv`
        base64 = this.cnpjRetorno.csv
      } else if (this.cpfRetorno !== null) {
        nomeArquivo = `pesquisa_cadastral_cpf.csv`
        base64 = this.cpfRetorno.csv
      } else if (this.cndRetorno !== null) {
        nomeArquivo = `pesquisa_cadastral_cnd.csv`
        base64 = this.cndRetorno.csv
      } else if (this.doiRetorno !== null) {
        nomeArquivo = `pesquisa_cadastral_doi.csv`
        base64 = this.doiRetorno.csv
      } else if (this.cafirRetorno !== null) {
        nomeArquivo = `pesquisa_cadastral_cafir.csv`
        base64 = this.cafirRetorno.csv
      }

      this.downloadArquivo(base64, nomeArquivo, 'text/csv')
    },

    exportarPdf() {
      let nomeArquivo;
      let base64;
      if (this.cnpjRetorno !== null) {
        nomeArquivo = `pesquisa_cadastral_cnpj.pdf`
        base64 = this.cnpjRetorno.pdf
      } else if (this.cpfRetorno !== null) {
        nomeArquivo = `pesquisa_cadastral_cpf.pdf`
        base64 = this.cpfRetorno.pdf
      } else if (this.cndRetorno !== null) {
        nomeArquivo = `pesquisa_cadastral_cnd.pdf`
        base64 = this.cndRetorno.pdf
      } else if (this.doiRetorno !== null) {
        nomeArquivo = `pesquisa_cadastral_doi.pdf`
        base64 = this.doiRetorno.pdf
      } else if (this.cafirRetorno !== null) {
        nomeArquivo = `pesquisa_cadastral_cafir.pdf`
        base64 = this.cafirRetorno.pdf
      }

      this.downloadArquivo(base64, nomeArquivo, 'application/pdf')
    },

    downloadArquivo(base64, nomeArquivo, contentType) {
      var a = document.createElement("a");
      a.href = `data:${contentType};base64,${base64}`;
      a.download = nomeArquivo
      a.click()
    },
    verificarRetornoMultiplo() {
      return (this.cnpjRetorno !== null && Array.isArray(this.cnpjRetorno.cnpjs) && this.cnpjRetorno.cnpjs.length > 1)
          || (this.cpfRetorno !== null && Array.isArray(this.cpfRetorno.cpfs) && this.cpfRetorno.cpfs.length > 1)
          || (this.doiRetorno !== null && Array.isArray(this.doiRetorno.dados) && this.doiRetorno.dados.length > 1)
          || (this.cndRetorno !== null && Array.isArray(this.cndRetorno.dados) && this.cndRetorno.dados.length > 1)
          || (this.cafirRetorno !== null && Array.isArray(this.cafirRetorno.dados) && this.cafirRetorno.dados.length > 1)

    }
  },

  mounted() {
    this.$store.commit("setMessages", {});
    this.urlApi = process.env.VUE_APP_ROOT_API;
    this.token = JSON.parse(this.$store.getters.getUser).access_token;
  }

}
</script>

<style>
  .row-dados {
    padding-left: 10%;
    padding-right: 10%;
  }
  .item-dados {
    color: #5C78B3;
    font-weight: bold;
    font-size: 0.87rem;
  }
  .valor-dados {
    color: #8ba2d7;
  }
  .item-direita {
    border-left: 2px solid black;
  }
  .table-sociedade {
    text-align: center;
  }
  .table-sociedade table th {
    color: #5C78B3 !important;
    font-weight: bold;
    font-size: 0.87rem;
  }
  .table-sociedade table td {
    color: #8ba2d7;
  }
</style>
